import { Row, Col } from "react-bootstrap";
import InputSearch from "../../../../../components/inputs/InputSelectSearch";
import { Toggle } from "rsuite";
import Multiselect from "../../../../../components/inputs/inputMultiSelect";
import InputForm from "../../../../../components/inputs/InputForm";
import { TypeDocument } from "../../../../../enums/TypeDocument.enum";

const InfoCaseScreen = ({
    values,
    errors,
    touched,
    onChange,
    handleBlur,
    distritos,
    areas,
    instancias,
    delitos,
    setFieldValue,
    materias,
    jurisprudenceTypes,
    regiones,
}: {
    values: any;
    errors: any;
    touched: any;
    onChange: any;
    handleBlur: any;
    distritos: any;
    areas: any;
    instancias: any;
    delitos: any;
    setFieldValue: any;
    materias: any;
    jurisprudenceTypes: any;
    regiones: any;
}) => {
    return (
        <div>
            <Row className="d-flex justify-content-around mt-3">
                <Col xs={12} md={3}>
                    <InputSearch
                        label="Región"
                        name="region"
                        value={values.region}
                        touched={touched.region}
                        error={errors.region}
                        values={regiones}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                        disabled={values.tag === TypeDocument.ACUERDOS}
                    />
                </Col>
                <Col xs={12} md={3}>
                    <InputSearch
                        label="Distritos"
                        name="district"
                        value={values.district}
                        touched={touched.district}
                        error={errors.district}
                        values={distritos[values.region] || []}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        disabled={!values.region || distritos.length === 0 || values.tag === TypeDocument.ACUERDOS}
                        required
                    />
                </Col>
                <Col xs={12} md={3}>
                    <InputSearch
                        label={values.tag !== TypeDocument.TESIS ? "Organo Jurisdiccional" : "Órgano emisor"}
                        name="area"
                        value={values.area}
                        touched={touched.area}
                        error={errors.area}
                        values={areas[values.district] || []}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        disabled={!values.district || areas[values.district]?.length === 0 || values.tag === TypeDocument.ACUERDOS ? true : false}
                        required
                    />
                </Col>
            </Row>

            <Row className="d-flex justify-content-around mt-3">
                {/* {values.tag !== TypeDocument.TESIS && ( */}
                <Col xs={12} md={3}>
                    <InputSearch
                        label={values.tag === TypeDocument.TESIS ? "Ramo" : "Materias"}
                        name="subject"
                        value={values.subject}
                        touched={touched.subject}
                        error={errors.subject}
                        values={materias}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                        disabled={values.tag === TypeDocument.ACUERDOS}
                    />
                </Col>
                {/* )}  */}
            </Row>
            {values.tag === TypeDocument.TESIS && (
                <>
                    <Row className="d-flex justify-content-around mt-3">
                        <Col xs={12} md={3}>
                            <InputForm
                                label="Clave de jurisprudencia"
                                name="jurisprudenceKey"
                                type="text"
                                value={values.jurisprudenceKey}
                                touched={touched.jurisprudenceKey}
                                error={errors.jurisprudenceKey}
                                onChangeMethod={onChange}
                                onBlurMethod={handleBlur}
                                required
                            />
                        </Col>
                        <Col xs={12} md={3}>
                            <InputForm
                                label="Nombre de jurisprudencia"
                                name="jurisprudence"
                                type="text"
                                value={values.jurisprudence}
                                touched={touched.jurisprudence}
                                error={errors.jurisprudence}
                                onChangeMethod={onChange}
                                onBlurMethod={handleBlur}
                                required
                            />
                        </Col>
                        <Col xs={12} md={3}>
                            <InputSearch
                                label="Tipo de Jurisprudencia"
                                name="jurisprudenceType"
                                value={values.jurisprudenceType}
                                touched={touched.jurisprudenceType}
                                error={errors.jurisprudenceType}
                                values={jurisprudenceTypes}
                                labelVal="name"
                                valueVal="name"
                                onChangeMethod={onChange}
                                onBlurMethod={handleBlur}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-around mt-3"></Row>
                </>
            )}
            {values.tag !== TypeDocument.TESIS && values.tag !== TypeDocument.ACUERDOS && (
                <Row className="d-flex justify-content-around mb-5">
                    <Col xs={12} md={6}>
                        <Multiselect
                            label="Seleccione los delitos"
                            optionsArray={delitos}
                            inputName="judgments"
                            multiselect={true}
                            onBlurMethod={handleBlur}
                            touched={touched.judgments}
                            errors={errors.judgments}
                            optionValue="_id"
                            optionName="name"
                            value={values.judgments}
                            isRequired
                            setFieldValue={setFieldValue}
                            isDisabled={delitos.length === 0}
                        />
                    </Col>
                </Row>
            )}
            {values.tag !== TypeDocument.TESIS && values.tag !== TypeDocument.ACUERDOS && (
                <>
                    <div className="text-center mb-3">
                        <span>Perspectivas</span>
                    </div>
                    <Row className="d-flex justify-content-around mb-5">
                        <Col xs={12} md={3} className="d-flex justify-content-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Infancia</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.childhood}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "childhood",
                                                    value: !values.childhood,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={3} className="d-flex justify-content-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Genero</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.genre}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "genre",
                                                    value: !values.genre,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={3} className="d-flex justify-content-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Relevancia</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.relevantCase}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "relevantCase",
                                                    value: !values.relevantCase,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={3} className="d-flex justify-content-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Intercultural</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.intercultural}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "intercultural",
                                                    value: !values.intercultural,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-around align-content-around ">
                        <Col xs={12} md={3} className="d-flex justify-content-center align-content-between">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Adulto mayor</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.olderPerson}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "olderPerson",
                                                    value: !values.olderPerson,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={3} className="d-flex justify-content-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Persona con discapacidad</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.disabilityPerson}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "disabilityPerson",
                                                    value: !values.disabilityPerson,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={3} className="d-flex justify-content-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Migrante</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.migrant}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "migrant",
                                                    value: !values.migrant,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={3} className="d-flex justify-content-center text-center">
                            <div className="d-flex flex-column gap-3 justify-content-around">
                                <div className="text-right">
                                    <span>Sexual</span>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Toggle
                                        checked={values.sexual}
                                        onChange={() =>
                                            onChange({
                                                target: {
                                                    name: "sexual",
                                                    value: !values.sexual,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default InfoCaseScreen;
